import script from "./nftCard.vue?vue&type=script&setup=true&lang=js"
export * from "./nftCard.vue?vue&type=script&setup=true&lang=js"

import "./nftCard.vue?vue&type=style&index=0&id=3a17e91b&lang=css"

const __exports__ = script;

export default __exports__